/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Template_Preset_LabelInputs */



/**
* | output |
* | --- |
* | "Template Preset" |
*
* @param {Transcript_Export_Template_Preset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_template_preset_label = /** @type {((inputs?: Transcript_Export_Template_Preset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Template_Preset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prereglage de modele")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlage")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modello predefinito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительно заданный шаблон")
	if (locale === "es") return /** @type {LocalizedString} */ ("Plantilla preestablecida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("模板预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テンプレートプリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेम्पलेट प्रीसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelo predefinido")
	return /** @type {LocalizedString} */ ("Template Preset")
});